// Main entry point for customizer functionality
import $ from "jquery";
import "./types/customizer-global";
import type { PPLRValues } from "./types/product-personalizer";

import { initializeScrollListener } from "./customizer/setup/initializeScrollListener";
import { setupConfigurations } from "./customizer/setup/setupConfigurations";
// Import setup functions
import { isCustomizerPage } from "./customizer/utils/pageChecks";

// Check if we're on the hat-customizer product page by URL
function isHatCustomizerProduct(): boolean {
	const pathname = window.location.pathname;
	return pathname.includes('/products/hat-customizer') || 
	       pathname.includes('/products/create-your-own');
}

export default function customizer() {
	// Only run on the hat-customizer product page
	if (!isHatCustomizerProduct()) {
		console.log("[CUSTOMIZER] Not on hat-customizer product page, skipping initialization");
		// Set ready flag to true to prevent loader from waiting
		(window as any).customizerReady = true;
		return;
	}
	
	// Initialize main setup
	initializeCustomizer();
}

function initializeCustomizer() {
	// Initialize global font state with default
	window.currentCustomizerFont = "HoodScript";
	
	// Set flag to indicate customizer is initializing
	(window as any).customizerReady = false;
	
	const POLLING_INTERVAL = 300;
	const checkForInputInterval = setInterval(() => {
		const canvasElement = document.getElementById("pplr_canvas");
		const scriptInput = document.querySelector(
			".pplr-script-text input",
		) as HTMLInputElement | null;

		if (canvasElement && scriptInput) {
			clearInterval(checkForInputInterval);
			console.log("Zepto canvas and input detected, initializing customizer");
			setupConfigurations(scriptInput);
			
			// Set flag to indicate customizer is fully ready
			(window as any).customizerReady = true;
			console.log("Customizer fully initialized and ready");
		}
	}, POLLING_INTERVAL);

	// Setup scroll listener if on correct page
	if (isCustomizerPage()) {
		initializeScrollListener();
	}
}

// Initialize customizer when DOM is ready
if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", () => {
		customizer();
	});
} else {
	// DOM is already loaded
	customizer();
}
